import { useMutation } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';

import StringConstants from '../../constants/StringConstants';
import { RENTAL_MANAGER_API_V1_PREFIX } from '../../constants/RouteConstants';
import makeRequest from '../../utils/makeRequestUtils';
import useRequestConfig from '../../hooks/useRequestConfig';

type CreateLeaseRequestBody = {
  propertyId: string;
  leaseType: string;
};

/**
 * Creates new lease
 *
 * @param {string} propertyId
 * @param {string} leaseType
 */
export const useCreateNewLease = (queryOptions = {}) => {
  const dispatch = useDispatch();
  const requestConfig = useRequestConfig(StringConstants.POST);

  const mutationFn = (data: CreateLeaseRequestBody) =>
    makeRequest({
      dispatch,
      endpoint: `${RENTAL_MANAGER_API_V1_PREFIX}/users/leasing/createNewLease`,
      requestConfig,
      config: { data },
    });

  return useMutation({ mutationFn, ...queryOptions });
};
